import { cn } from '@/lib/utils'
import type { VoiceStatus } from '@/hooks/useVoice'

export default function VoiceBtn({
  status = 'idle',
  onClick,
}: {
  status?: VoiceStatus
  onClick?: () => void
}) {
  return (
    <div
      onClick={onClick}
      className={cn(
        'h-10 w-10 rounded-full flex items-center justify-center cursor-pointer transition-colors',
        status === 'idle'
          ? 'bg-[#F5F7FA]'
          : 'bg-[#131921]'
      )}
    >
      {status === 'loading' ? (
        <span className="size-4 border-2 border-white border-t-transparent rounded-full animate-spin"></span>
      ) : (
        <div
          className={cn(
            'font_family icon-yinliangguan text-2xl!',
            status === 'recording' ? 'text-white animate-pulse' : 'text-[rgb(48,49,51)]'
          )}
        ></div>
      )}
    </div>
  )
}
